import {
    FETCH_CONTACT_TYPES,
} from '../../mutation-types';

export default {
  [FETCH_CONTACT_TYPES](state, contactTypes) {
    state.contactTypes = contactTypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/contactTypes/mutations.js